import React, { Component } from 'react';
import Header from '../header';
import './style.scss';

class BuildYourTeamThankYou extends Component {
  constructor(){
    super();
  }
  render(){
    return(
      <div key="page-build-thank" className="page">
        <Header animation={false}/>
        <section className='build-team-thank-page'>
          <div className="single-column">
            <h2>App2soft Thanks You</h2>
            <p>We thank you for submitting the information, one of our Account Managers will contact you soon to give you more information of the selected team.
            </p>
          </div>
        </section>
      </div>
    )
  }
}

export default BuildYourTeamThankYou;



// WEBPACK FOOTER //
// ./src/components/build-your-team-thank-you/index.js